import {
    LOAD_ANSWERS_SUCCESS, RESET_ANSWERS, REORDER_ANSWERS_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_ANSWERS_SUCCESS:
            return action.payload;
        case REORDER_ANSWERS_SUCCESS:
            return action.payload;
        case RESET_ANSWERS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/AnswersReducer.js